import { render, staticRenderFns } from "./MultiButton.vue?vue&type=template&id=5251807a&scoped=true"
import script from "./MultiButton.vue?vue&type=script&lang=js"
export * from "./MultiButton.vue?vue&type=script&lang=js"
import style0 from "./MultiButton.vue?vue&type=style&index=0&id=5251807a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5251807a",
  null
  
)

export default component.exports